import { render, staticRenderFns } from "./PriceTab.vue?vue&type=template&id=12a0b1c2&scoped=true&"
import script from "./PriceTab.vue?vue&type=script&lang=js&"
export * from "./PriceTab.vue?vue&type=script&lang=js&"
import style0 from "./PriceTab.vue?vue&type=style&index=0&id=12a0b1c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a0b1c2",
  null
  
)

export default component.exports